import { useParams } from "react-router-dom";
import GeneralRevenue from "./GeneralRevenue";

const MAP = [
  {
    category: "revenue",
    pages: [
      { name: "member", title: "Member Revenue", adaptedType: "Member" },
      { name: "walk-in", title: "Walk-in Revenue", adaptedType: "Guest" },
      {
        name: "transactions",
        title: "Transactions Report",
        adaptedType: "Transactions",
      },
      { name: "void", title: "Void Report", adaptedType: "Void" },
      { name: "all", title: "All Revenue", adaptedType: "All" },
      {
        name: "member's transactions",
        title: "Member's Transactions",
        adaptedType: "Member's T",
      },
      {
        name: "walk-in's transactions",
        title: "Walk-in's Transactions",
        adaptedType: "Walkin's T",
      },
    ],
  },
  {
    category: "customer",
    pages: [
      { name: "bigspender", title: "Big Spenders", adaptedType: "Bigspender" },
      { name: "frequent", title: "Frequent Members", adaptedType: "Frequent" },
      { name: "member", title: "Member Report", adaptedType: "Member" },
      { name: "walk-in", title: "Walk-in Report", adaptedType: "Guest" },
      { name: "all", title: "All Customer Report", adaptedType: "All" },
    ],
  },
  {
    category: "loyalty",
    pages: [
      { name: "total", title: "Total Earn Points", adaptedType: "Total" },
      { name: "earn", title: "Total Earn Points", adaptedType: "Earn" },
      { name: "redeem", title: "Total Redeem Points", adaptedType: "Redeem" },
      {
        name: "remaining",
        title: "Total Remaining Points",
        adaptedType: "Remaining",
      },
      { name: "tiers", title: "Tiers Report", adaptedType: "Tiers" },
    ],
  },
  {
    category: "product",
    pages: [
      { name: "product", title: "Product Report", adaptedType: "Product" },
      { name: "category", title: "Category Report", adaptedType: "Category" },
      {
        name: "subcategory",
        title: "Sub-Category Report",
        adaptedType: "Subcategory",
      },
    ],
  },
  {
    category: "ranking",
    pages: [
      { name: "payment", title: "Top Payment Method", adaptedType: "Payment" },
      {
        name: "product",
        title: "Top Products",
        adaptedType: "Product",
      },

      {
        name: "category",
        title: "Top Product Categories",
        adaptedType: "Category",
      },

      {
        name: "bigspender",
        title: "Top Big Spenders",
        adaptedType: "Bigspender",
      },
      {
        name: "frequent",
        title: "Top Frequent Members",
        adaptedType: "Frequent",
      },
    ],
  },
];

const Revenue = () => {
  const { type, id } = useParams();

  const { title, adaptedType } = MAP.find(
    (m) => m.category === type
  )?.pages.find((p) => p.name === id) ?? {
    title: id + " Report",
    adaptedType: "tier-" + id,
  };

  return (
    <GeneralRevenue
      title={title}
      type={adaptedType}
      pageCatType={type}
      selectedDate={{
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      }}
    />
  );
};

export default Revenue;
